import { Box, styled, Theme, Typography } from '@mui/material';
import { palette } from 'view/themes/palette';

export const ModalMainWrapper = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '560px',
    height: 'max-content',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: palette.white,
    border: `1px solid ${palette.border.default}`,
    borderRadius: '24px',
    boxShadow: 'none',
    padding: '32px',
    outline: 'none',

    [theme.breakpoints.down('tablet')]: {
      width: '100%',
      height: '100%',
      borderRadius: 0,
      padding: '32px 16px',
    },

    [theme.mediaQueries.landscapeMobile]: {
      width: '100%',
      height: '100vh',
      maxHeight: '100vh',
      overflow: 'auto',
      padding: '0 12px 24px 12px',
      borderRadius: 0,
    },
  };
}) as typeof Box;

export const CloseIconBox = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '20px',
    height: '20px',
    position: 'absolute',
    right: '24px',
    top: '24px',
    outline: 'none',
    cursor: 'pointer',
    opacity: 0.7,

    '&:hover': {
      opacity: 1,
      svg: {
        path: {
          /* fill: 'red', */
        },
      },
    },
  };
}) as typeof Box;

export const ModalMainBox = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1,
    marginBottom: '24px',
  };
}) as typeof Box;

export const ModalMainImage = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    margin: '21px 0 24px 0',
  };
}) as typeof Box;

export const ModalMainHeader = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px',
    whiteSpace: 'pre-line',
    textAlign: 'center',

    [theme.breakpoints.down('tablet')]: {
      whiteSpace: 'normal',
    },
  };
}) as typeof Box;

export const ModalMainHeaderTitle = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    fontSize: '24px',
    fontWeight: 700,
    lineHeight: '29px',
    color: palette.text.header,
  };
}) as typeof Typography;

export const ModalMainHeaderSubTitle = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    color: palette.text.body,
  };
}) as typeof Typography;

export const ModalMainFooter = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    display: 'flex',
    alignItems: 'stretch',
    gap: '12px',

    [theme.breakpoints.down('iphone5')]: {
      flexDirection: 'column',
    },
  };
}) as typeof Box;
